// import { sidebarAccessManager } from '@core/utils/accessManager'

export default [
  {
    path: '/:accountId/forecasting',
    name: 'forecasting',
    component: () => import('@/views/client/properties/Forecasting.vue'),
    meta: {
      pageTitle: 'ClientPortal.SideMenu.Forecasting',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Forecasting',
          active: true,
        },
      ],
    },
  },
  {
    path: '/:accountId/earnings',
    name: 'earnings',
    component: () => import('@/views/client/properties/catalogs/Earnings/Earnings.vue'),
    meta: {
      pageTitle: 'ClientPortal.SideMenu.Earnings',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Earnings',
          active: true,
        },
      ],
    },
  },
  {
    path: '/:accountId/properties',
    name: 'properties',
    component: () => import('@/views/client/properties/properties/Properties.vue'),
    meta: {
      pageTitle: 'ClientPortal.SideMenu.Properties',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Properties',
          active: true,
        },
      ],
    },
  },
  {
    path: '/:accountId/property/details',
    query: { propertyId: '' },
    name: 'property-details',
    component: () => import('@/views/client/properties/properties/Placement.vue'),
    meta: {
      pageTitle: 'ClientPortal.SideMenu.Properties.PropertyDetails',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Properties',
          to: '/properties',
        },
        {
          text: 'ClientPortal.SideMenu.Properties.PropertyDetails',
          active: true,
        },
      ],
    },
  },
  {
    path: '/:accountId/property/placement',
    query: { propertyId: '', placementId: '' },
    name: 'create-placement',
    component: () => import('@/views/client/properties/properties/Create.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Properties',
          to: '/properties',
        },
        {
          text: 'ClientPortal.SideMenu.Properties.PropertyDetails',
        },
        {
          text: 'ClientPortal.SideMenu.Properties.CreatePlacement',
          active: true,
        },
      ],
    },
    beforeEnter: (to, from, next) => {
      to.meta.pageTitle = to.query.placementId ? 'ClientPortal.SideMenu.Properties.EditPlacement' : 'ClientPortal.SideMenu.Properties.CreatePlacements'
      to.meta.breadcrumb[2].text = to.query.placementId ? 'ClientPortal.SideMenu.Properties.EditPlacement' : 'ClientPortal.SideMenu.Properties.CreatePlacements'
      to.meta.breadcrumb[1].to = `/property/details?propertyId=${to.query.propertyId}#placements`
      next()
    },
  },
  {
    path: '/:accountId/nativeadtemplate',
    name: 'targeting',
    component: () => import('@/views/client/properties/properties/Templates.vue'),
    meta: {
      pageTitle: 'ClientPortal.SideMenu.Properties.Templates',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Properties',
          to: '/properties',
        },
        {
          text: 'ClientPortal.SideMenu.Properties.PropertyDetails',
          to: '/properties',
        },
        {
          text: 'ClientPortal.SideMenu.Properties.PropertyDetails.Edit',
          to: '/properties',
        },
        {
          text: 'ClientPortal.SideMenu.Properties.Templates',
          active: true,
        },
      ],
    },
  },
  {
    path: '/:accountId/nativeadtemplate/edit',
    name: 'create-template',
    component: () => import('@/views/client/properties/properties/CreateTemplate.vue'),
    props: route => ({
      templateId: route.query.templateId,
    }),
    meta: {
      pageTitle: 'ClientPortal.SideMenu.Properties.Templates',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Properties',
          to: '/properties',
        },
        {
          text: 'ClientPortal.SideMenu.Properties.PropertyDetails',
          to: '/properties',
        },
        {
          text: 'ClientPortal.SideMenu.Properties.PropertyDetails.Edit',
          to: '/properties',
        },
        {
          text: 'ClientPortal.SideMenu.Properties.Templates',
          to: '/nativeadtemplate',
        },
        {
          text: 'ClientPortal.SideMenu.Properties.Template',
          active: true,
        },
      ],
    },
  },
  {
    path: '/:accountId/property/targeting',
    query: { propertyId: '', targetingPropertyId: '' },
    name: 'create-placement',
    component: () => import('@/views/client/properties/properties/Targeting.vue'),
    meta: {
      pageTitle: 'ClientPortal.SideMenu.Properties.Targeting',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Properties',
          to: '/properties',
        },
        {
          text: 'ClientPortal.SideMenu.Properties.PropertyDetails',
        },
        {
          text: 'ClientPortal.SideMenu.Properties.TargetingProperty',
          active: true,
        },
      ],
    },
    beforeEnter: (to, from, next) => {
      to.meta.pageTitle = to.query.targetingPropertyId ? 'ClientPortal.SideMenu.Properties.EditTargetingProperty' : 'ClientPortal.SideMenu.Properties.CreateTargetingProperty'
      to.meta.breadcrumb[2].text = to.query.targetingPropertyId ? 'ClientPortal.SideMenu.Properties.EditTargetingProperty' : 'ClientPortal.SideMenu.Properties.CreateTargetingProperty'
      to.meta.breadcrumb[1].to = `/property/details?propertyId=${to.query.propertyId}#targeting`
      next()
    },
  },
  {
    path: '/:accountId/audiences',
    name: 'audiences',
    component: () => import('@/views/client/properties/Audiences.vue'),
    meta: {
      pageTitle: 'ClientPortal.SideMenu.Audiences',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Audiences',
          active: true,
        },
      ],
    },
  },
]
